export const keyMap = {
    БИК: 'bic',
    ИП: 'ip',
    Код: 'code',
    'Краткое наименование на рус. яз.': 'name',
    ФЛ: 'fl',
    ЮЛ: 'ul',
    '№№': 'index',
};
